import React from 'react';
import { LoginFormPasswordStyle as S } from './LoginFormPassword.style';
import { useLoginPageBLoC } from 'modules/PublicModule/pages/LoginPage/LoginPage.bloc';
import { useObservableState } from 'observable-hooks';
import { PasswordInput } from 'components/PasswordInput/PasswordInput';
import { FormField } from 'components/FormField/FormField';
import { Text } from 'components/Text/Text';

export const LoginFormPassword: React.FC = () => {
  const { form, loginFailed, $showErrors } = useLoginPageBLoC();
  const showErrors = useObservableState($showErrors, false);
  const showPasswordError = loginFailed && showErrors;

  return (
    <S.InputContainer $showPasswordError={!!showPasswordError}>
      <FormField
        form={form}
        controller={{
          name: 'password',
          rules: {
            required: 'Please enter a password',
            maxLength: 255,
          },
        }}
        label="Password"
      >
        {({ field, fieldState }) => (
          <>
            <PasswordInput {...field} invalid={fieldState.invalid} data-testid="input-login-password" />
            {showPasswordError && (
              <S.CustomError>
                <Text
                  as="span"
                  color="rose600"
                  size="fontSizeXS"
                  lineHeight="lineHeightSM"
                  transform="upper-first-letter"
                  data-testid="label-login-invalid-credentials"
                  className="label-login-invalid-credentials"
                >
                  The email and password don’t match. Please try again.
                </Text>
              </S.CustomError>
            )}
          </>
        )}
      </FormField>
    </S.InputContainer>
  );
};
